import styled from 'styled-components';

import Button from '../Button/Button';
import Heading from '../Heading/Heading.styled';

export const PurchaseButtonStyled = styled(Button)`
  margin: 30px 0;
`;

export const EmptyWrapperStyled = styled.div`
  text-align: center;
`;

export const EmptyMessageStyled = styled.p`
  margin: 20px 0 0;
`;

export const DetailsList = styled.ul`
  ${({ theme }) => `
    li { 
      font-size: ${theme.fontSizes.small};
      
      &:last-child {
        margin-top: 20px;
      }

      & + li {
        margin-top: 5px; 
      }
    }  
  `}
`;

export const TotalSummaryRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 5px;
  padding-top: 5px;
  margin-top: 20px;
  border-top: 1px solid #dbdbdb;
`;

export const SummaryItemsListStyled = styled.ul`
  li {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    & > button {
      flex: auto;
      text-align: left;
    }

    ${({ theme }) => `
      font-size: ${theme.fontSizes.small};  
    `}

    &:first-child {
      padding-top: 5px;
      margin-top: 10px;
      border-top: 1px solid #dbdbdb;
    }

    & + li {
      margin-top: 20px;
    }
  }
`;

export const PriceWrapperStyled = styled.span`
  flex: none;
`;

export const RowStyled = styled.div`
  & + & {
    margin-top: 25px;
  }
`;

export const TitleStyled = styled(Heading).attrs(({ level }) => (level ? { level } : { level: 5 }))`
  color: #000;
`;
